import { isNotNullOrUndef } from '../../utils/isNotNullOrUndef';
const vNode = window.vNode;
export const createWishlistButton = (item, styles = '', colored = false) => {
    return vNode.create('component-wishlist-button', {
        class: `wishlist__button async-styles ${styles}`,
        hidden: true,
        'data-action': 'wishlist-toggle',
        'data-sku': item.sku,
        'data-id': item.shopify_id,
        'data-title': item.title,
        'data-handle': item.url.replace('/products/', ''),
        'data-image': item.main_image,
        'data-image3d': isNotNullOrUndef(item.layouts) && item.layouts.length > 0 ? item.layouts.find(l => l.type === 'Multiple')?.preview_3d ?? item.layouts[0].preview_3d : '',
        'data-url': item.url,
        'data-current-count': item.wish_count,
        'aria-label': 'Wishlist. ',
        'data-active': 0
    }, [
        vNode.create('span', { class: 'wishlist__loader' }, [
            vNode.create('s-svg', { class: 'wishlist__heart-empty', 'data-icon': '#icon--heart-empty' }),
            vNode.create('s-svg', { class: 'wishlist__heart-filled', 'data-icon': colored ? '#icon--wishlist-color' : '#icon--heart-filled' })
        ]),
        vNode.create('span', { 'data-wish-counter': '' }, [item.wish_count])
    ]);
};
